import DashboardLayout from "@/PageComponents/Dashboard/DashboardLayout";
import { colors, shadows } from "@/theme";
import { FC } from "react";
import { Responsive, WidthProvider, Layout } from "react-grid-layout";
import {Box, ScrollArea} from "@mantine/core";


const DashboardPageComponent: FC<{testing: boolean}> = ({ testing = false}: any) => {

    return (
        <>
            <Box
                bg={'#F5F5F5'}
            >
                <DashboardLayout testing={testing}/>
            </Box>
        </>);
};

export default DashboardPageComponent;